import type { SiteEntity } from '@common/types/site.type';
import type { SitePage } from '@common/types/site-page.type';
import type { Template } from '@common/types/template.type';
import type { ELanguages, UserPlatform, EAppMode } from '@common/enums';

import { createActionGroup, emptyProps, props } from '@ngrx/store';

const AppActions = createActionGroup({
    source: 'App',
    events: {
        'Init App': emptyProps(),
        'Init App Request': props<{
            site?: SiteEntity;
            template?: Template;
            currentPage?: SitePage;
            pages?: SitePage[];
            total?: number;
        }>(),
        'Init App Success': emptyProps(),
        'Init App Failure': props<{ error: string }>(),
        'Init Site': emptyProps(),
        'Init New Site': emptyProps(),
        'Init New Page': emptyProps(),
        'Init Admin': emptyProps(),
        'Init Ecommerce': emptyProps(),
        'Init New Site From Template': emptyProps(),
        'Init New Page From Template': emptyProps(),
        'Init Exit': props<{ isRedirectTabClose?: boolean }>(),
        Exit: props<{ isRedirectTabClose?: boolean }>(),
        'Set is admin': props<{ isAdmin: boolean }>(),
        'Set mode': props<{ mode: EAppMode }>(),
        'Set locale': props<{ locale: ELanguages }>(),
        'Set platform': props<{ platform: UserPlatform }>(),
        'Update session': emptyProps(),
        'Intro finished': emptyProps(),
        'Data Layer Request': emptyProps(),
        'Set data layer': props<{ dataLayer: any }>(),
        // 'Show confirm delete user library block modal': props<{ blockId: Uuid }>(),
    },
});

export default AppActions;
